import type { SecurityGetAllOptInsV1Params, SecurityOptIn } from '@shipium-corp/shipium-ts-types';
import GatewayAxiosClient from '~/store/services/GatewayAxiosClient';

export const optIns = {
  search: {
    queryKey: 'security-service/opt-ins',
    configurationType: 'cached' as const,
    fn: async (params: SecurityGetAllOptInsV1Params = { includeInactive: false }) => {
      const { data } = await GatewayAxiosClient.get<SecurityOptIn[]>('/optIns/getOptIns', {
        params,
      });

      return data;
    },
  },
  partnerList: {
    queryKey: 'security-service/opt-ins/partner-list',
    configurationType: 'cached' as const,
    fn: async (partnerId: string) => {
      const { data } = await GatewayAxiosClient.get<SecurityOptIn[]>(`/optIns/${partnerId}/getPartnerOptIns`);

      return data;
    },
  },
};
